import React, { useState } from "react";
import { Card, Tabs, Space } from "antd";
import { useGlobal } from "../../contexts/GlobalContext";
import SummaryTab from "../../componets/admin/dataControl/SummaryTab";
import ChatHistoryTab from "../../componets/admin/dataControl/ChatHistoryTab";
import MailLogsTab from "../../componets/admin/dataControl/MailLogsTab";
import SensitiveWordsTab from "../../componets/admin/dataControl/SensitiveWordsTab";
import TokenLogsTab from "../../componets/admin/dataControl/TokenLogsTab";
import "remixicon/fonts/remixicon.css";
import HotWordTab from "../../componets/admin/dataControl/HotWordTab";
import PodcastTab from "../../componets/admin/dataControl/PodcastTab";
import { isSuperAdminRole } from "../../utils/roles";

const DataControlPanel: React.FC = () => {
  const { API_BASE_URL, token, user } = useGlobal();
  const isSuperAdmin = isSuperAdminRole(user?.apiInfo?.role);
  // 默认选中第一个可见 Tab(superadmin 首个是"摘要",普通 admin 首个是"热词"),避免选中项与首 Tab 不一致。
  const [activeTab, setActiveTab] = useState<string>(isSuperAdmin ? "summary" : "hotwords");

  if (!token) {
    return null;
  }

  const tabItems = [
    {
      key: "summary",
      label: (
        <span>
          <i className="ri-file-text-line" style={{ marginRight: 8 }} />
          摘要列表
        </span>
      ),
      children: <SummaryTab API_BASE_URL={API_BASE_URL} token={token} />,
    },
    {
      key: "hotwords",
      label: (
        <span>
          <i className="ri-bookmark-line" style={{ marginRight: 8 }} />
          热词管理
        </span>
      ),
      children: <HotWordTab API_BASE_URL={API_BASE_URL} token={token} />,
    },
    {
      key: "chat",
      label: (
        <span>
          <i className="ri-message-3-line" style={{ marginRight: 8 }} />
          聊天记录
        </span>
      ),
      children: <ChatHistoryTab API_BASE_URL={API_BASE_URL} token={token} />,
    },
    {
      key: "token",
      label: (
        <span>
          <i className="ri-coin-line" style={{ marginRight: 8 }} />
          Token消耗
        </span>
      ),
      children: <TokenLogsTab API_BASE_URL={API_BASE_URL} token={token} />,
    },
    {
      key: "mail",
      label: (
        <span>
          <i className="ri-mail-line" style={{ marginRight: 8 }} />
          邮件日志
        </span>
      ),
      children: <MailLogsTab API_BASE_URL={API_BASE_URL} token={token} />,
    },
    {
      key: "sensitive",
      label: (
        <span style={{ display: "flex", alignItems: "center" }}>
          <i className="ri-alert-line" style={{ marginRight: 8 }} />
          敏感词记录
          <a
            href="https://github.com/TIANLI0/tianligpt_go/blob/v2/files/sensitive_words.txt"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: 8, color: "#1677ff", fontSize: 16 }}
            title="编辑敏感词"
            onClick={(e) => e.stopPropagation()}
          >
            <i className="ri-edit-2-line" />
          </a>
        </span>
      ),
      children: <SensitiveWordsTab API_BASE_URL={API_BASE_URL} token={token} />,
    },
    {
      key: "podcast",
      label: (
        <span>
          <i className="ri-mic-line" style={{ marginRight: 8 }} />
          AI播客
        </span>
      ),
      children: <PodcastTab />,
    },
  ].filter((item) => isSuperAdmin || (item.key !== "summary" && item.key !== "chat"));

  return (
    <div
      style={{
        background: "#f0f2f5",
        minHeight: "100%",
        borderRadius: 8,
        padding: "16px",
      }}
    >
      <Card
        title={
          <Space>
            <i
              className="ri-database-2-line"
              style={{ color: "#1677ff", fontSize: 20 }}
            />
            <span>数据管控面板</span>
          </Space>
        }
        style={{ marginBottom: 16 }}
        variant="outlined"
      >
        <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
      </Card>
    </div>
  );
};

export default DataControlPanel;
